import notifyMessages from "./notifyMessages";
import computedQueries from "./computedQueries";

export default {
  mixins: [ computedQueries, notifyMessages ],

  methods: {
    // canLoadMore has to be passed as string. It needs to be checked every single time
    // an entry fires, as it's value passed as prop in to this function is not reactive
    initInfiniteLoad(resourceName, target, canLoadMore, url, options = {root: null, rootMargin: '0px', threshold: 1.0}) {
      let callback = (entries, observer) => {
        entries.forEach(entry => {
          if(entry.isIntersecting && this[canLoadMore]) {
            this.getPaginatedResource({key: resourceName, url})
              .catch(() => this.notifyStoreError())
          }
        });
      };

      let observer = new IntersectionObserver(callback, options);
      observer.observe(target);
    }
  },
}